import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  Autocomplete,
  Select,
  MenuItem,
  FormControl,
  Checkbox,
  FormControlLabel,
  ListItemText,
  Box,
  InputLabel,
  createFilterOptions,
} from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import allDxCodes from "../Data/DXCode";
import {
  getAllVisitReasons,
  getDxCode,
  getFacilityByProviderId,
  getPatientByProviderId,
} from "../api/action";
import { useDispatch, useSelector } from "react-redux";
import CopyDataModal from "./CopyDataModal";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { sanitizeInput, hasCSVInjectionChar, containsDangerousHtml } from "../Utils/validationSecurity";
import { SUPERBILL_FIELD_RULES } from "../Utils/validationSchemas";

const CustomTable = ({
  state,
  setState,
  handleAddTimeSheet,
  updated,
  copyData,
  setCopyData,
  initialRowState,
  facility,
  setFacility,
  dos,
  setDos
}) => {
  const [provider, setProvider] = useState( useSelector((state) => state?.user?.userName));
  const [providerId, setProviderId] = useState( useSelector((state) => state?.user?.userId));
  const [profileId, setProfileId] = useState( useSelector((state) => state?.user?.profileId));
  const [allPatient, setAllPatient] = useState([]);
  const [allCpt, setAllCpt] = useState([]);
  const [admissions, setAdmissions] = useState([]);
  const [filteredDxCodes, setFilteredDxCodes] = useState(allDxCodes);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({});
  const [facilityTypeName, setFacilityTypeName] = useState("");
  const [facilityTypeId, setFacilityTypeId] = useState("");
  // const [dos, setDos] = useState(null);
  // const [facility, setFacility] = useState(null);
  const [allFacilities, setAllFacilities] = useState([]);
  const [open, setOpen] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [dxCode, setDxCode] = useState([]);
  const [dob, setDob] = useState("");
  const [firstname, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [rowErrors, setRowErrors] = useState({});
  const dispatch = useDispatch();

  const validateField = (rowIndex, fieldName, value) => {
    const rules = SUPERBILL_FIELD_RULES[fieldName];
    if (!rules) return;

    const sanitized = sanitizeInput(value);
    let error = null;

    if (sanitized) {
      if (hasCSVInjectionChar(sanitized)) {
        error = `${rules.label} must not start with +, -, @, or =`;
      } else if (containsDangerousHtml(sanitized)) {
        error = `${rules.label} must not contain HTML tags, scripts, or event handlers`;
      } else if (rules.pattern && !rules.pattern.test(sanitized)) {
        error = rules.patternMsg;
      } else if (sanitized.length > rules.max) {
        error = `${rules.label} must be at most ${rules.max} characters`;
      }
    }

    setRowErrors(prev => ({
      ...prev,
      [rowIndex]: { ...(prev[rowIndex] || {}), [fieldName]: error }
    }));
  };

  const handleDeleteRow = (index) => {
    setState((prevState) => prevState.filter((_, i) => i !== index));
    setRowErrors(prev => {
      const updated = {};
      Object.keys(prev).forEach(key => {
        const k = Number(key);
        if (k < index) updated[k] = prev[k];
        else if (k > index) updated[k - 1] = prev[k];
      });
      return updated;
    });
  };

  useEffect(() => {
    setLoading(true);
    const payload = null;
    dispatch(
      getDxCode(
        payload,
        (data) => {
          setLoading(false);
          setDxCode(data?.data?.Data || []);
        },
        (error) => {
          console.log(error);
          setLoading(false);
        }
      )
    );
  }, [updated]);

  useEffect(() => {
    if (state === null) {
      setCopyData([]);
    }
  }, [state]);

  useEffect(() => {
    setFacility(null);
    setFacilityTypeId("");
    setFacilityTypeName("");
  }, [filteredData]);

  useEffect(() => {
    if (!facility && state && state.length > 0 && state[0].facility_master) {
      setFacility(state[0].facility_master);
      setFacilityTypeName(state[0].facility_type?.facility_type_Name);
      setFacilityTypeId(state[0].facility_type?.id);
    }
  }, [state]);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();

    return `${year}-${month}-${day}`;
  }

  function convertToFormattedString(data) {
    if (Array.isArray(data)) {
      if (data.length === 0) {
        return "";
      } else if (typeof data[0] === "string") {
        return data.join(", ").toUpperCase();
      } else if (typeof data[0] === "object" && data[0].Code) {
        return data.map((item) => item.Code).join(", ");
      }
    }
    return "";
  }

  // useEffect(() => {
  //   setCopyData([])
  // }, [updated]);

  useEffect(() => {
    setLoading(true);
    const payload = null;
    dispatch(
      getAllVisitReasons(
        payload,
        (data) => {
          setLoading(false);
          setAllCpt(data?.data?.Data);
        },
        (error) => {
          console.log(error);
          setLoading(false);
        }
      )
    );
  }, [dispatch]);

  useEffect(() => {
    setLoading(true);
    const payload = null;
    dispatch(
      getPatientByProviderId(
        payload,
        profileId,
        (data) => {
          setLoading(false);

          const seen = new Set();
          const uniquePatients = data?.data?.reduce((acc, patient) => {
            const key = `${patient.conclude_patient_data.firstName}-${patient.conclude_patient_data.lastName}-${patient.conclude_patient_data.dob}`;
            if (!seen.has(key)) {
              seen.add(key);
              acc.push(patient);
            }
            return acc;
          }, []);

          setAllPatient(uniquePatients);
        },
        (error) => {
          console.log(error);
          setLoading(false);
        }
      )
    );
  }, []);

  useEffect(() => {
    setLoading(true);
    const payload = null;
    dispatch(
      getFacilityByProviderId(
        payload,
        providerId,
        (data) => {
          setLoading(false);
          setAllFacilities(data?.data?.Data);
        },
        (error) => {
          console.log(error);
          setLoading(false);
        }
      )
    );
  }, []);

  const handleNameSelect = (selectedName, index) => {
    const selectedPatient = allPatient.find(
      (patient) =>
        `${patient.conclude_patient_data?.firstName} ${patient.conclude_patient_data?.lastName} ${patient?.conclude_patient_data?.dob}` ===
        selectedName
    );
    if (selectedPatient) {
      setState((prevState) => {
        const newState = [...prevState];
        newState[index] = {
          ...newState[index],
          patient_name: selectedPatient?.conclude_patient_data?.firstName,
          last_name: selectedPatient?.conclude_patient_data?.lastName,
          dob: selectedPatient?.conclude_patient_data?.dob,
        };
        return newState;
      });

      const updatedInitialRowState = {
        ...initialRowState,
        patient_name: selectedPatient?.conclude_patient_data?.firstName,
        last_name: selectedPatient?.conclude_patient_data?.lastName,
        dob: selectedPatient?.conclude_patient_data?.dob,
      };

      setState((prevState) => {
        const newState = [...prevState];
        newState[index] = { ...updatedInitialRowState };
        return newState;
      });
    }
  };

  const handleInputChange = (index, field, value) => {
    if (field === "dob" || field === "date_of_service") {
      const formattedDate = dayjs(value).format("MM/DD/YYYY");
      setState((prevState) => {
        const newState = [...prevState];
        newState[index] = { ...newState[index], [field]: formattedDate };
        return newState;
      });
    } else if (field === "dx_code") {
      const formattedDxCode = value
        .map((item) => {
          if (typeof item === "object" && item.Code) {
            return item.Code;
          } else if (typeof item === "string") {
            return item;
          }
          return null;
        })
        .filter((item) => item !== null);

      setState((prevState) => {
        const newState = [...prevState];
        newState[index] = { ...newState[index], [field]: formattedDxCode };
        return newState;
      });
    } else if (field === "dob") {
      const formattedDate = formatDate(value);
      setState((prevState) => {
        const newState = [...prevState];
        newState[index] = { ...newState[index], [field]: formattedDate };
        return newState;
      });
    } else if (field === "cpt_code") {
      const formattedCPTCode = value
        .map((item) => {
          if (typeof item === "object" && item?.visit_reason_code) {
            return item.visit_reason_code;
          } else if (typeof item === "string") {
            return item;
          }
          return null;
        })
        .filter((item) => item !== null);

      setState((prevState) => {
        const newState = [...prevState];
        newState[index] = { ...newState[index], [field]: formattedCPTCode };
        return newState;
      });
    } else {
      setState((prevState) => {
        const newState = [...prevState];
        newState[index] = { ...newState[index], [field]: value };
        return newState;
      });
      if (SUPERBILL_FIELD_RULES[field]) {
        validateField(index, field, value);
      }
    }
  };

  const addRow = () => {
    setState((prevState) => [...prevState, { ...initialRowState }]);
  };

  const commonInputSx = {
    width: "100% !important",
    minWidth: "10rem !important",
    "& .MuiOutlinedInput-root": {
      height: "32px !important",
      fontSize: "12px",
      padding: "4px 10px !important",
    },
    "& .MuiOutlinedInput-input": {
      padding: "0px !important",
      fontSize: "12px",
    },
    "& .MuiAutocomplete-root": {
      height: "28px",
    },
  };

  const filter = createFilterOptions();

  const hasData = state?.some((row) => {
    return (
      row.patient_name?.trim() ||
      row.last_name?.trim() ||
      row.dob ||
      row.cpt_code?.length > 0 ||
      row.dx_code?.length > 0 ||
      row.admission?.trim() ||
      row.reason_for_visit?.trim() ||
      row.comment?.trim() ||
      row.modifier?.trim()
    );
  });

  return (
    <div>
      <CopyDataModal
        open={open}
        setOpen={setOpen}
        copyData={copyData}
        setCopyData={setCopyData}
        setFilteredData={setFilteredData}
        filteredData={filteredData}
      />
      <Box sx={{ display: "flex", mb: 2, justifyContent: "space-between" }}>
        <Box sx={{ display: "flex" }}>
          <Box>
            <InputLabel>Facility Name</InputLabel>
            <Autocomplete
              required
              // className="scrollBar"
              fullWidth
              value={facility}
              onChange={(event, newValue) => {
                setFacility(newValue);
                setFacilityTypeId(newValue?.facility_type_id);
                setFacilityTypeName(newValue?.facility_type_Name);

                // Update only the facility-related fields
                setState((prevState) =>
                  prevState.map((row) => ({
                    ...row,
                    facility_master: newValue?.id,
                    facility_type: newValue?.facility_type_id,
                  }))
                );
              }}
              sx={{ width: "30rem !important", mr: 0 }}
              clearIcon={null}
              options={allFacilities}
              getOptionLabel={(option) => option.facility_name}
              getOptionSelected={(option, value) => option.id === value.id}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  sx={{
                    "& input": {
                      height: "0px",
                      fontSize: "14px",
                      width: "30rem !important",
                    },
                  }}
                />
              )}
            />
          </Box>

          <Box sx={{ mx: 2 }}>
            <InputLabel>Facility Type</InputLabel>
            <TextField
              sx={{ fontSize: "14px" }}
              className="tableCellWidth"
              variant="outlined"
              value={facilityTypeName}
              disabled
              InputProps={{ style: { height: "2rem" } }}
            />
          </Box>

        <Box>
          <InputLabel>Date of Service</InputLabel>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={dos ? dayjs(dos) : null}
              onChange={(newValue) => {
                setDos(newValue);
                setState((prevState) =>
                  prevState.map((row) => ({
                    ...row,
                    date_of_service: newValue ? formatDate(newValue) : "",
                  }))
                );
              }}
              className="tableCellWidth"
              disableFuture
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  className="tableCellWidth"
                  style={{ height: "10px !important" }}
                />
              )}
            />
          </LocalizationProvider>
        </Box>
        </Box>

        <Button
          elevation={0}
          variant="contained"
          color="primary"
          onClick={() => setOpen(true)}
          sx={{ marginTop: "10px", boxShadow: "none" }}
        >
          Copy Data
        </Button>
      </Box>
      <TableContainer component={Paper} className="scrollBar">
        <Table>
          <TableHead sx={{ background: "#1D3969" }}>
            {[
              "",
              "First Name*",
              "Last Name*",
              "DOB*",
              "CPT Code*",
              "DX Code*",
              "Admission",
              "Modifier",
              "Reason",
              "Comment",
            ].map((h) => (
              <TableCell
                key={h}
                sx={{
                  color: "#fff",
                  py: 0.5,
                  whiteSpace: "nowrap",
                  fontSize: "12px",
                }}
              >
                {h}
              </TableCell>
            ))}
          </TableHead>
          <TableBody>
            {state?.map((row, index) => (
              <TableRow key={index}>
                <TableCell sx={{ py: 0.5, px: 0.5 }}>
                  <IconButton
                    color="error"
                    size="small"
                    onClick={() => handleDeleteRow(index)}
                  >
                    <DeleteIcon fontSize="small" sx={{color:'#1D3969'}} />
                  </IconButton>
                </TableCell>
                <TableCell sx={{ py: 0.5, px: 0.5 }}>
                  <Autocomplete
                    freeSolo
                    disabled={!facility}
                    options={allPatient}
                    value={row.patient_name || ""}
                    // ✅ store both typed and selected values
                    onInputChange={(event, newInputValue) => {
                      handleInputChange(
                        index,
                        "patient_name",
                        newInputValue || ""
                      );
                    }}
                    onChange={(event, newValue) => {
                      if (typeof newValue === "string") {
                        // ✅ if typed directly
                        handleInputChange(index, "patient_name", newValue);
                        handleInputChange(index, "last_name", "");
                        handleInputChange(index, "dob", "");
                      } else if (newValue) {
                        // ✅ if selected from list
                        handleInputChange(
                          index,
                          "patient_name",
                          newValue?.conclude_patient_data?.firstName || ""
                        );
                        handleInputChange(
                          index,
                          "last_name",
                          newValue?.conclude_patient_data?.lastName || ""
                        );
                        handleInputChange(
                          index,
                          "dob",
                          newValue?.conclude_patient_data?.dob || ""
                        );
                      } else {
                        handleInputChange(index, "patient_name", "");
                      }
                    }}
                    // ✅ search works for firstName, lastName, dob
                    getOptionLabel={(option) => {
                      if (typeof option === "string") return option;
                      if (!option?.conclude_patient_data) return "";
                      const { firstName, lastName, dob } =
                        option.conclude_patient_data;
                      return `${firstName || ""} ${lastName || ""} ${
                        dob || ""
                      }`.trim();
                    }}
                    renderOption={(props, option) => (
                      <li {...props}>
                        {option.conclude_patient_data.firstName}{" "}
                        {option.conclude_patient_data.lastName}{" "}
                        {option.conclude_patient_data.dob}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        sx={commonInputSx}
                        error={!!rowErrors[index]?.patient_name}
                        helperText={rowErrors[index]?.patient_name || `${(row.patient_name || '').length}/50`}
                        FormHelperTextProps={{
                          sx: {
                            textAlign: rowErrors[index]?.patient_name ? "left" : "right",
                            fontSize: "11px",
                            mx: 0,
                          },
                        }}
                        inputProps={{ ...params.inputProps, maxLength: 50 }}
                      />
                    )}
                  />
                </TableCell>

                <TableCell sx={{ py: 0.5, px: 0.5 }}>
                  <TextField
                    className="tableCellWidth"
                    variant="outlined"
                    value={row.last_name || ""}
                    onChange={(e) =>
                      handleInputChange(index, "last_name", e.target.value)
                    }
                    disabled={!facility}
                    sx={commonInputSx}
                    error={!!rowErrors[index]?.last_name}
                    helperText={rowErrors[index]?.last_name || `${(row.last_name || '').length}/50`}
                    FormHelperTextProps={{
                      sx: {
                        textAlign: rowErrors[index]?.last_name ? "left" : "right",
                        fontSize: "11px",
                        mx: 0,
                      },
                    }}
                    inputProps={{ maxLength: 50 }}
                  />
                </TableCell>

                <TableCell sx={{ py: 0.5, px: 0.5 }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      disabled={!facility}
                      value={row.dob ? dayjs(row.dob) : null}
                      onChange={(newValue) =>
                        handleInputChange(
                          index,
                          "dob",
                          newValue ? dayjs(newValue).format("MM/DD/YYYY") : ""
                        )
                      }
                      className="tableCellWidth"
                      disableFuture
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          className="tableCellWidth"
                          sx={{ height: "32px" }}
                          inputProps={{
                            ...params.inputProps,
                            style: { textAlign: "center" },
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </TableCell>

                <TableCell sx={{ py: 0.5, px: 0.5 }}>
                  <Autocomplete
                   disabled={!facility || !(row.patient_name && row.last_name)}
                    className="scrollBar"
                    fullWidth
                    multiple
                    disableCloseOnSelect
                    options={allCpt}
                    onChange={(event, newValue) =>
                      handleInputChange(
                        index,
                        "cpt_code",
                        newValue.map((item) => item.visit_reason_code) // ✅ store only codes
                      )
                    }
                    value={
                      row?.cpt_code
                        ? row.cpt_code.map(
                            (code) =>
                              allCpt.find(
                                (cpt) => cpt.visit_reason_code === code
                              ) || {
                                visit_reason_code: code,
                                visit_reason_description: "",
                              }
                          )
                        : []
                    }
                    sx={{
                      width: "13rem !important",
                      height: "100% !important",
                      fontSize: "10px !important",
                    }}
                    clearIcon={null}
                    isOptionEqualToValue={(option, value) =>
                      option.visit_reason_code === value.visit_reason_code
                    }
                    getOptionLabel={(option) =>
                      `${option.visit_reason_code} ${
                        option.visit_reason_description || ""
                      }`
                    }
                    renderOption={(props, option) => (
                      <li {...props}>
                        <FormControlLabel
                          sx={{ fontSize: "10px !important" }}
                          control={
                            <Checkbox
                              sx={{
                                transform: "scale(0.75)",
                                "& .MuiSvgIcon-root": { fontSize: 22 },
                              }}
                              checked={Array.isArray(row?.cpt_code) && row.cpt_code.includes(
                                option.visit_reason_code
                              )}
                            />
                          }
                          label={
                            <ListItemText
                              sx={{
                                "& .MuiTypography-root": {
                                  fontSize: "12px !important",
                                },
                              }}
                              primary={`${option.visit_reason_code} ${option.visit_reason_description}`}
                            />
                          }
                        />
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        sx={{
                          "& input": {
                            height: "0px",
                            fontSize: "14px",
                            width: "10vw !important",
                            overflowX: "auto !important",
                          },
                        }}
                      />
                    )}
                  />
                </TableCell>

                <TableCell sx={{ py: 0.5, px: 0.5 }}>
                  <Autocomplete
                   disabled={!facility || !(row.patient_name && row.last_name)}
                    className="scrollBar"
                    fullWidth
                    multiple
                    disableCloseOnSelect
                    onChange={(event, newValue) =>
                      handleInputChange(
                        index,
                        "dx_code",
                        newValue.map((item) => item.dx_reason_code) // ✅ store only codes
                      )
                    }
                    value={
                      row?.dx_code
                        ? row.dx_code.map(
                            (code) =>
                              dxCode.find(
                                (dx) => dx.dx_reason_code === code
                              ) || {
                                dx_reason_code: code,
                                dx_reason_description: "",
                              }
                          )
                        : []
                    }
                    sx={{
                      width: "13rem !important",
                      height: "100% !important",
                      fontSize: "10px !important",
                    }}
                    clearIcon={null}
                    options={dxCode}
                    isOptionEqualToValue={(option, value) =>
                      option.dx_reason_code === value.dx_reason_code
                    }
                    getOptionLabel={(option) =>
                      `${option.dx_reason_code} ${
                        option.dx_reason_description || ""
                      }`
                    }
                    renderOption={(props, option) => (
                      <li {...props}>
                        <FormControlLabel
                          sx={{ fontSize: "10px !important" }}
                          control={
                            <Checkbox
                              sx={{
                                transform: "scale(0.75)",
                                "& .MuiSvgIcon-root": { fontSize: 22 },
                              }}
                              checked={Array.isArray(row?.dx_code) && row.dx_code.includes(
                                option.dx_reason_code
                              )}
                            />
                          }
                          label={
                            <ListItemText
                              sx={{
                                "& .MuiTypography-root": {
                                  fontSize: "12px !important",
                                },
                              }}
                              primary={`${option.dx_reason_code} ${option.dx_reason_description}`}
                            />
                          }
                        />
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        sx={{
                          "& input": {
                            height: "0px",
                            fontSize: "14px",
                            width: "10vw !important",
                            overflowX: "auto !important",
                          },
                        }}
                      />
                    )}
                  />
                </TableCell>

                <TableCell sx={{ py: 0.5, px: 0.5 }}>
                  <FormControl fullWidth variant="outlined">
                    <Select
                     disabled={!facility || !(row.patient_name && row.last_name)}
                      className="tableCellWidth"
                      value={row.admission}
                      onChange={(e) =>
                        handleInputChange(index, "admission", e.target.value)
                      }
                      displayEmpty
                    >
                      {["Yes", "No"].map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell sx={{ py: 0.5, px: 0.5 }}>
                  <TextField
                    disabled={!facility}
                    sx={{ fontSize: "14px" }}
                    className="tableCellWidth"
                    variant="outlined"
                    value={row.modifier}
                    onChange={(e) =>
                      handleInputChange(index, "modifier", e.target.value)
                    }
                    InputProps={{ style: { height: "2rem" } }}
                    error={!!rowErrors[index]?.modifier}
                    helperText={rowErrors[index]?.modifier || `${(row.modifier || '').length}/10`}
                    FormHelperTextProps={{
                      sx: {
                        textAlign: rowErrors[index]?.modifier ? "left" : "right",
                        fontSize: "11px",
                        mx: 0,
                      },
                    }}
                    inputProps={{ maxLength: 10 }}
                  />
                </TableCell>
                <TableCell sx={{ py: 0.5, px: 0.5 }}>
                  <FormControl fullWidth variant="outlined">
                    <Select
                      disabled={!facility}
                      className="tableCellWidth"
                      value={row.reason_for_visit}
                      onChange={(e) =>
                        handleInputChange(
                          index,
                          "reason_for_visit",
                          e.target.value
                        )
                      }
                      displayEmpty
                      // sx={{ color: '#a2a2a2' }}
                    >
                      {/* <MenuItem value="" disabled sx={{ fontSize: "12px" }}>
                                                Reason
                                            </MenuItem> */}
                      {[
                        "Follow Up",
                        "Initial",
                        "ED Consult",
                        "IOP",
                        "CL-Medsurg Consult",
                        "Discharge",
                      ].map((option) => (
                        <MenuItem
                          key={option}
                          value={option}
                          sx={{ fontSize: "12px" }}
                        >
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell
                  sx={{
                    py: 0.5,
                    px: 0.5,
                    height: "auto !important",
                  }}
                >
                  <TextField
                    disabled={!facility}
                    value={row.comment}
                    multiline
                    minRows={1}
                    onChange={(e) =>
                      handleInputChange(index, "comment", e.target.value)
                    }
                    sx={{
                      width: "100%",
                      "& .MuiInputBase-root": {
                        fontSize: "14px",
                        lineHeight: "1.4rem",
                        padding: "6px",
                        height: "auto !important",
                      },
                    }}
                    error={!!rowErrors[index]?.comment}
                    helperText={rowErrors[index]?.comment || `${(row.comment || '').length}/1000`}
                    FormHelperTextProps={{
                      sx: {
                        textAlign: rowErrors[index]?.comment ? "left" : "right",
                        fontSize: "11px",
                        mx: 0,
                      },
                    }}
                    inputProps={{ maxLength: 1000 }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Button
        variant="contained"
        color="primary"
        onClick={addRow}
        style={{ marginTop: "10px" }}
      >
        Add Row
      </Button>
      <Button
        variant="contained"
        color="primary"
        onClick={handleAddTimeSheet}
        disabled={!hasData}
        style={{ marginTop: "10px", marginLeft: "10px" }}
      >
        Save
      </Button>
    </div>
  );
};

export default CustomTable;
 